export default __webpack_public_path__ + "static/farid-shabanov-c2f5343cbf21ad9a5fd6a8b4e9ec3e5e.png";